import Simulator from "./components/Simulator";

export default function CoralReefApp() {
  return <Simulator />;
}
